import { getToApi, postToApi, deleteToApi } from './axios';

// API wrappers para la foto del item del catalogo (coleccion_items.image_key).
// Patron calcado de api/signatures.js: presigned PUT directo a S3, confirm
// persiste la key, url devuelve presigned GET, delete limpia S3 + columna.

/**
 * Pide al backend una URL presigned PUT para subir la foto de un item a S3.
 * @param {number|string} itemId
 * @param {'image/jpeg'|'image/png'|'image/webp'} contentType
 * @returns {Promise<{ uploadUrl: string, key: string, expiresAt: string }>}
 */
export const presignColeccionItemImageUpload = async (itemId, contentType) => {
  const response = await postToApi(`/colecciones/items/${itemId}/image/presign-upload`, {
    contentType,
  });
  const data = response.data || response;
  if (data.state !== 'success') {
    throw new Error(data.message || 'Error generando presigned URL');
  }
  return {
    uploadUrl: data.uploadUrl,
    key: data.key,
    expiresAt: data.expiresAt,
  };
};

/**
 * Confirma el upload: persiste image_key y borra la imagen previa si existia.
 * @param {number|string} itemId
 * @param {string} key — la key devuelta por presign-upload
 * @returns {Promise<string>} la image_key persistida
 */
export const confirmColeccionItemImage = async (itemId, key) => {
  const response = await postToApi(`/colecciones/items/${itemId}/image/confirm`, { key });
  const data = response.data || response;
  if (data.state !== 'success') {
    throw new Error(data.message || 'Error confirmando la imagen');
  }
  return data.image_key;
};

/**
 * Obtiene una URL presigned GET (1h) para mostrar la foto del item.
 * @param {number|string} itemId
 * @returns {Promise<string>}
 */
export const getColeccionItemImageUrl = async (itemId) => {
  const data = await getToApi(`/colecciones/items/${itemId}/image/url`);
  if (data.state !== 'success') {
    throw new Error(data.message || 'Error obteniendo URL de imagen');
  }
  return data.url;
};

/**
 * Borra la foto del item (S3 + columna). Idempotente.
 * @param {number|string} itemId
 * @returns {Promise<void>}
 */
export const deleteColeccionItemImage = async (itemId) => {
  await deleteToApi(`/colecciones/items/${itemId}/image`);
};
